export default "__VITE_ASSET__DubMjVkk__"